Ext.define('SA.model.LocationHasEnabledSubGeoUnitsPredicate', {
    test({geoUnits, location}) {
        return geoUnits.getEnabledSubGeoUnitsForLocation(location).length > 0;
    }
});